<template>
  <DropdownComponent v-if="value.length" class="brochure" :placement="placement">
    <ButtonComponent
      :theme="theme"
      :icon="['far', 'arrow-down']"
      :label="actionLabel"
      @click="hasMany ? () => {} : download(value[0])"
    />
    <template #dropdown>
      <span></span>
      <template v-if="hasMany">
        <ButtonComponent
          v-for="(item, index) in value"
          :key="index"
          :icon="['fad', 'file-pdf']"
          :label="item.name"
          @click="download(item)"
        />
      </template>
    </template>
  </DropdownComponent>
</template>

<script>
import { DropdownComponent } from 'vue-elder-dropdown'
import { EventBus as AssetBus } from '@kvass/asset-manager'
import { Capitalize } from '@/utils'

export default {
  props: {
    value: Array,
    theme: {
      type: String,
      default: 'primary',
    },
    label: String,
    placement: {
      type: String,
      default: 'bottom-end',
    },
  },
  computed: {
    hasMany() {
      return this.value.length > 1
    },
    brochureStrategy() {
      return KvassConfig.get('siteSettings.brochureDownloadStrategy')
    },
    actionLabel() {
      return this.label || this.$t('assetManagerTitleBrochure' + Capitalize(this.brochureStrategy))
    },
  },
  methods: {
    download(item) {
      AssetBus.emit('download', {
        type: 'brochure',
        strategy: this.brochureStrategy,
        asset: item,
      })
    },
  },
  components: {
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.brochure {
  color: $dark;
}
</style>
